export enum Source {
  DOC = 'doc',
  DOWNLOAD_META = 'download-meta',
  MARKETPLACE_ENTRY = 'marketplace-entry',
  CLOUD_LEARNING_CONTENT = 'cloud-learning-content',
}

export enum EntityType {
  /** A scheduled activity like a meetup or training class  */
  EVENT = 'EVENT',
  /** A forum post with zero or more replies */
  THREAD = 'THREAD',
  /** A published article (also used for Antora-style docs) */
  ARTICLE = 'ARTICLE',
  /** A sub-section of an article where article or document is composed of multiple parts */
  SECTION = 'SECTION',
  /** Book is a collection of related and structured articles or legacy documentation */
  BOOK = 'BOOK',
  /** A chapter of a book containinga sub-set of articles*/
  BOOK_CHAPTER = 'BOOK_CHAPTER',
  /** A downloadable software artifact */
  SOFTWARE_ARTIFACT = 'SOFTWARE_ARTIFACT',
  /** Learning Path - an online self-paced curriculum of study composed of one or more chapters of content */
  PATH = 'PATH',
  /** Learning path chapter - contains a collection of related learning resources */
  PATH_CHAPTER = 'PATH_CHAPTER',
  /** A practical online learning exercise (e.g. a Cloudshare Lab)  */
  EXERCISE = 'EXERCISE',
  /** An eBook that provides instructions or guidance */
  GUIDE = 'GUIDE',
  /** A multimedia online lesson (typically a video but 'mediaType' will define the format)  */
  LESSON = 'LESSON',
  /** An aggregated collection of links to other content */
  FEED = 'FEED'
}

export enum MediaType {
  /** Some kind of playable video file */
  VIDEO = 'VIDEO',
  /** HTML content viewable in the browser */
  HTML = 'HTML',
  /** An ebook that will require some kind of app or reader to view */
  EBOOK = 'EBOOK',
  /** AN RSS feed that aggregates other content */
  RSS = 'RSS'
}

export enum Group {
  MULTIMEDIA = 'MULTIMEDIA',
  TRAINING = 'TRAINING',
  SOFTWARE = 'SOFTWARE'
}

